import { Injectable } from '@angular/core'
import { AppStorageService } from '../app-storage.service';
import { StorageKeys } from '../storage-keys';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(private storage: AppStorageService) {}

  language: string = 'es'

  langs = [
    {
      name: 'English',
      flag: '../../../assets/flags/gb.svg',
      value: 'en'
    },
    {
      name: 'Español',
      flag: '../../../assets/flags/es.svg',
      value: 'es'
    },
    {
      name: 'Français',
      flag: '../../../assets/flags/fr.svg',
      value: 'fr'
    },
    {
      name: 'Deutsch',
      flag: '../../../assets/flags/de.svg',
      value: 'de'
    },
    {
      name: 'Italiano',
      flag: '../../../assets/flags/it.svg',
      value: 'it'
    },
    {
      name: 'Português',
      flag: '../../../assets/flags/pt.svg',
      value: 'pt'
    },
    {
      name: 'Català',
      flag: '../../../assets/flags/ca.svg',
      value: 'ca'
    }
  ]

  async isFirstTimeOpening(): Promise<boolean> {
    const hasOpenedBefore = this.storage.get(StorageKeys.HAS_OPENED_BEFORE)
    return !hasOpenedBefore
  }

  async setAppOpened(): Promise<void> {
    this.storage.set(StorageKeys.HAS_OPENED_BEFORE, 'true')
  }

  async getSelectedLang() {
    let lang = this.storage.get(StorageKeys.LANG)

    if (!lang) {
      return null
    }

    const result = this.langs.find(({ value }) => value === lang)
    return result
  }

  async getLangs() {
    return this.langs
  }

  async setLang(lang: string) {
    this.storage.set(StorageKeys.LANG, lang)
  }
}
